import * as styles from './PromotionHeader.css';
import { PromotionSectionHeader } from '../PromotionSectionHeader';
import { ServicesLayoutToggleContainer } from '../ServicesLayoutToggle';
import * as React from 'react';

export const PromotionHeader = () => {
  return (
    <div className={styles.root}>
      <PromotionSectionHeader />

      <ServicesLayoutToggleContainer />
    </div>
  );
};
